import { useQuery } from "react-query";
import { getSafeType } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useSafeType = () => {
  const { data, isLoading, refetch } = useQuery("GetSafeType", getSafeType, {
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, refetch };
};
